import { defineStore } from 'pinia'

import { StoreId } from '@/store'
import { DEFAULT_BASKET_UNAVAILABLE_STATE } from '@/store/basket/basket.constants'
import { BasketUnavailableStore } from '@/store/basket/basket.types'

export const useBasketUnavailableStore = defineStore(
  StoreId.BASKET_UNAVAILABLE,
  {
    state: (): BasketUnavailableStore => DEFAULT_BASKET_UNAVAILABLE_STATE,
    actions: {
      setUnavailableItems(state: BasketUnavailableStore) {
        Object.assign(DEFAULT_BASKET_UNAVAILABLE_STATE, state)
      },
      clearBasketUnavailableState() {
        this.$state.unavailable_product_ids = []
        this.$state.price_changed_products = []
        this.$state.id_changed_products = []
        this.$state.changed_delivery_cost = null
      },
    },
    getters: {
      isBasketItemsUnavailable({
        unavailable_product_ids,
        price_changed_products,
        id_changed_products,
      }: BasketUnavailableStore) {
        return (
          unavailable_product_ids.length ||
          price_changed_products.length ||
          id_changed_products.length
        )
      },
    },
  },
)
